import { createAppTableSaga, createAppTableStore } from 'components/AppTable/store';

export const projectBudgetReportSlice = createAppTableStore({
  name: 'projectBudgetReport' as const,
  url: '',
  initialState: {
    params: {
      sort: { column: 'date', order: 'ascend' },
      filters: {
        entry_type: [
          { value: 'credit', label: 'Credit' },
          { value: 'timelog', label: 'Timelog' },
          { value: 'allocation', label: 'Allocation' },
          { value: 'expiration', label: 'Expiration' },
        ],
      },
    },
    paramFilterFields: {
      date_start: 'date[from]',
      date_end: 'date[to]',
      entry_type: 'entry_type',
    },
    fixedParams: { include: 'allocations' },
    serverControl: false,
  },
});

export const projectBudgetReportSaga = createAppTableSaga(projectBudgetReportSlice);

export const projectBudgetReportReducer = projectBudgetReportSlice.reducer;
